/**
 * Méthode qui contrôle un champ en ayant un caractère en upperCase
 * @param value valeur du champ
 */
export function controlUpperCase(value: string) {
    return /[A-Z]/.test(value);
}

/**
 * Méthode qui contrôle un champ en ayant un caractère en lowerCase
 * @param value valeur du champ
 */
export function controlLowerCase(value: string) {
    return /[a-z]/.test(value);
}

/**
 * Méthode qui contrôle un champ en ayant un caractère en numeric
 * @param value valeur du champ
 */
export function controlNumeric(value: string) {
    return /\d/.test(value);
}

/**
 * Méthode qui contrôle un champ en ayant un caractère special
 * @param value valeur du champ
 */
export function controlSpecific(value: string) {
    return /[!@#%&]/.test(value);
}

/**
 * Méthode qui contrôle un champ sur sa taille
 * @param value valeur du champ
 * @param minLength taille min
 */
export function controlLengthMin(value: string, minLength: number) {
    const length = value.length;
    return (minLength && length >= minLength) || !minLength;
}

/**
 * Méthode qui contrôle un champ sur sa taille
 * @param value valeur du champ
 * @param maxLength taille max
 */
export function controlLengthMax(value: string, maxLength: number) {
    const length = value.length;
    return (maxLength && length <= maxLength) || !maxLength;
}
